import { SRCImage } from "react-datocms";

import { graphql, type FragmentOf } from "~/lib/dato-graphql";
import { placePropsFragment, responsiveImageFragment } from "~/lib/fragments";
import { Link } from "~/navigation";

export const placeCardFragment = graphql(
  `
    fragment PlaceCardFragment on PlaceCardRecord @_unmask {
      __typename
      id
      place {
        id
        title
        slug
        heroImage {
          responsiveImage(
            imgixParams: { auto: format, fit: crop, w: 120, h: 120 }
          ) {
            ...ResponsiveImageFragment
          }
          alt
          title
        }
      }
    }
  `,
  [placePropsFragment, responsiveImageFragment],
);

export function PlaceCard({
  place,
}: {
  place: FragmentOf<typeof placeCardFragment>["place"];
}) {
  return (
    <Link href={`/places/${place.slug}/${place.id}`}>
      <div className="relative flex gap-4 overflow-hidden rounded-2xl">
        <SRCImage data={place.heroImage.responsiveImage} />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-b from-transparent to-black/40" />
        <div className="absolute inset-x-0 bottom-0 px-4 py-2 text-white">
          <h3 className="mb-2 truncate text-balance font-medium sm:text-lg">
            {place.title}
          </h3>
        </div>
      </div>
    </Link>
  );
}
